<script>
  import { useLocation, useNavigate } from "svelte-navigator";
  import { ROUTES } from "@utils/routes.js";
  import { useUrlParams } from "@stores/urlStore.js";
  import { projectListStore } from "@stores/damProjectsStore.js";
  import { pageTitleStore } from "@stores/pageTitleStore.js";
  import { Header } from "paxray-components-svelte";

  export let section = "define section";
  export let breadcrumb = "define breadcrumb";
  export let area = "";
  export let areaHref = "";
  export let areaClickable = true;
  export let projectHref = "";
  export let projectIdOverride = "";
  export let projectNameOverride = "";
  export let hideProjectName = false;
  export let tooltipText = "";
  export let showTooltip = true;
  export let updatePageTitle = true;
  export let breadcrumbsClickable = true;
  export let paddingRight = true;

  const location = useLocation();
  const navigate = useNavigate();
  const urlParams = useUrlParams();
  const { loadProjectName, getProjectName } = projectListStore;

  $: ({ analysisid } = $urlParams);
  $: idproject = projectIdOverride || $urlParams.idproject;
  $: if (idproject) {
    getProjectName(idproject);
  } else if (analysisid) {
    loadProjectName(analysisid);
  } else {
    loadProjectName(null);
  }

  $: ({ currentProjectName } = $projectListStore);
  $: projectName = hideProjectName
    ? ""
    : projectNameOverride || currentProjectName || "";
  $: pathname = $location?.pathname || window.location.pathname;

  $: if (updatePageTitle) {
    pageTitleStore.set({
      pathname,
      section,
      breadcrumb,
    });
  }

  function navigateTo(href) {
    const url = new URL(href, window.location.href);
    if (url.origin !== window.location.origin) {
      window.location.assign(url.href);
      return;
    }
    navigate(`${url.pathname}${url.search}${url.hash}`);
  }

  function openProject() {
    navigateTo(projectHref || ROUTES.dam.root);
  }

  function openProjectProgress() {
    if (!idproject) return;
    const params = new URLSearchParams({ idproject });
    if (analysisid) params.set("analysisid", analysisid);
    navigateTo(`${ROUTES.dam.progress}?${params.toString()}`);
  }

  function openArea() {
    if (!areaClickable) return;
    if (areaHref) {
      navigateTo(areaHref);
      return;
    }
    openProjectProgress();
  }
</script>

<Header
  {section}
  {breadcrumb}
  {area}
  {areaHref}
  {areaClickable}
  {projectHref}
  projectNameOverride={projectName}
  {hideProjectName}
  {updatePageTitle}
  {showTooltip}
  {tooltipText}
  {breadcrumbsClickable}
  {paddingRight}
  onProjectClick={projectHref || idproject ? openProject : null}
  onAreaClick={areaHref || idproject ? openArea : null}
>
  <slot />
</Header>
